var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMixes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5H2.5V6.66667H12.5V5ZM12.5 8.33333H2.5V10H12.5V8.33333ZM2.5 13.3333H9.16667V11.6667H2.5V13.3333ZM14.1667 5V11.8167C13.9083 11.725 13.625 11.6667 13.3333 11.6667C11.95 11.6667 10.8333 12.7833 10.8333 14.1667C10.8333 15.55 11.95 16.6667 13.3333 16.6667C14.7167 16.6667 15.8333 15.55 15.8333 14.1667V6.66667H18.3333V5H14.1667Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixes);
export default __webpack_public_path__ + "static/media/mixes.0f12d0ffeae963b025ee0aae32378cae.svg";
export { ForwardRef as ReactComponent };